//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import React from 'react';
import ResourcesCard, { CardData } from '../card/resourcesCard';
import plan from '../../icons/plan_black.png';
import control from '../../icons/control_black.png';
import velocity from '../../icons/velocity_black.png';
import test from '../../icons/test_black.png';
import deploy from '../../icons/deploy_black.png';
import code from '../../icons/code_black.png';
import build from '../../icons/build_black.svg';
import { resourcesStyles } from '../../styles/resourcesStyles';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../../Config';
import settings from '../../Config/settings';

type ResourcesProps = {
  cardsData?: CardData[];
};

type Provider = keyof typeof settings.links;
type LinkCategory = string;

function getButtonLinks(title: LinkCategory, provider: Provider): string[] {
  const providerLinks = settings.links[provider];
  if (!providerLinks) return ['#', '#', '#'];

  const gsgLinks = providerLinks.gsg as Record<string, string>;
  const udLinks = providerLinks.ud as Record<string, string>;

  const gsgLink = gsgLinks[title] || '#';
  const udLink = udLinks[title] || '#';

  return [gsgLink, udLink];
}

function Resources({ cardsData }: ResourcesProps) {
  const { t } = useTranslation();
  const { services } = useConfig();
  const provider = (services?.provider?.name || '') as Provider;

  const defaultCardsData: CardData[] = [
    {
      title: `${t('devops')} ${t('plan')}`,
      imageURL: plan,
      buttonLinks: getButtonLinks('plan', provider),
    },
    {
      title: `${t('devops')} ${t('control')}`,
      imageURL: control,
      buttonLinks: getButtonLinks('control', provider),
    },
    {
      title: `${t('devops')} ${t('deploy')}`,
      imageURL: deploy,
      buttonLinks: getButtonLinks('deploy', provider),
    },
    {
      title: `${t('devops')} ${t('test')}`,
      imageURL: test,
      buttonLinks: getButtonLinks('test', provider),
    },
    {
      title: `${t('devops')} ${t('velocity')}`,
      imageURL: velocity,
      buttonLinks: getButtonLinks('velocity', provider),
    },
    {
      title: `${t('devops')} ${t('code')}`,
      imageURL: code,
      buttonLinks: getButtonLinks('code', provider),
    },
    {
      title: `${t('devops')} ${t('build')}`,
      imageURL: build,
      buttonLinks: getButtonLinks('build', provider),
    },
  ];

  if (provider === 'IBM') {
    defaultCardsData.push({
      title: `${t('devops')} ${t('model')}`,
      imageURL: build,
      buttonLinks: getButtonLinks('model', provider),
    });
  }

  return (
    <div
      style={{ ...resourcesStyles.container, backgroundColor: 'white' }}
      id="resources-container"
      data-testid="resources-container"
    >
      <ResourcesCard cardsData={cardsData || defaultCardsData} />
    </div>
  );
}

export default Resources;
